import _ from 'lodash';

import { ia, iaRa, io } from 'lib/helpers/utility';

import { formatSections } from 'components/shared/Forms/Custom/lib/generalFormatFormHelperV3';

const isObjectType = ({ value = null }) => {
  if (!value) return false;

  return typeof value === 'object' && !Array.isArray(value) && value !== null;
};

const getEventValue = ({ event }) => {
  if (!event) return null;

  if (isObjectType({ value: event?.target?.value })) {
    return event?.target?.value;
  }

  return event;
};

const checkIfCustomFormsAreSame = ({
  oldChanges,
  newChanges,
  isCustomForm = false,
  targetFormName
}) => {
  // TEMPORARY FIX
  // Custom forms (e.g., allergies, social history, family history, surgical history, etc.)
  // should always have the narrative field filled. When a form has "Custom forms", onChange is triggered initially
  // without user input, causing "newChanges" to be null and ignoring the narrative.
  // To handle this, we check if the narrative inside the custom form is null.
  // If it is, we assume it's the first time the form is being called and return true.
  if (!newChanges?.narrative && isCustomForm) {
    return true;
  }

  if (!oldChanges || !newChanges || !isCustomForm) return false;

  let parsedFields = typeof oldChanges == 'string' ? JSON.parse(oldChanges) : oldChanges;

  parsedFields = iaRa(parsedFields)?.find((field) => {
    if (field.name === targetFormName) {
      return field;
    }
  })?.value;

  const stringifyParsedFields =
    typeof parsedFields != 'string' ? JSON.stringify(parsedFields) : parsedFields;

  const stringifyNewChanges =
    typeof newChanges != 'string' ? JSON.stringify(newChanges) : newChanges;

  return stringifyParsedFields == stringifyNewChanges;
};

export const handleOnChange = ({
  e = null,
  isMounted = false,
  currentForm = null,
  syncON = true,
  formResponse = null,
  queryClient,
  queryKey,

  setCurrentForm = () => null,
  setFormUpdated = () => null,
  setNarrativeUpdated = () => null
}) => {
  if (!isMounted) return;

  const event = getEventValue({ event: e });

  if (
    checkIfCustomFormsAreSame({
      oldChanges: currentForm?.json?.fields,
      newChanges: event?.target?.value,
      isCustomForm: event?.target?.type === 'custom',
      targetFormName: e?.target?.name
    })
  ) {
    return;
  }

  setCurrentForm((prev) => {
    const updatedForm = _.cloneDeep(prev);

    if (isFormObjectAvailable(updatedForm)) {
      updatedForm.json.fields = JSON.stringify(formResponse);
    } else {
      updatedForm['form'] =
        typeof prev.json.fields === 'string'
          ? { ...prev, json: { ...prev.json, fields: JSON.parse(prev.json.fields) } }
          : { ...prev };
      updatedForm.json.fields = JSON.stringify(formResponse);
    }

    const formattedSections = formatSections({
      fieldData: updatedForm?.form?.json?.fields,
      answerData: formResponse ?? JSON.parse(updatedForm?.json?.fields)
    });

    if (syncON) {
      updatedForm['narrative'] = formattedSections;
      setNarrativeUpdated(true);
    }

    updatedForm['simple_narrative'] = formattedSections;

    queryClient.setQueryData(queryKey, (oldData) => {
      const newData = { ...(oldData || {}) };

      if (!newData?.data) {
        newData.data = {};
      }

      newData.data.formResponse = updatedForm;

      return newData;
    });

    setFormUpdated(true);
    return updatedForm;
  });
};

const isFormObjectAvailable = (form) => {
  return io(form?.form);
};

export const hasFormData = (currForm) => {
  const fields = io(currForm?.form) ? currForm?.form?.json?.fields : currForm?.json?.fields;
  return typeof fields !== 'string';
};

export const generateNarrative = ({
  currentForm = null,
  setCurrentForm = () => null,
  setNarrativeUpdated = () => null
}) => {
  let narrative = '',
    isCustomForm = false;

  const fields =
    typeof currentForm?.json?.fields === 'string'
      ? JSON.parse(currentForm?.json?.fields)
      : currentForm?.json?.fields;

  if (ia(fields)) {
    fields.forEach((field) => {
      const isValueTypeOfObject = isObjectType({ value: field?.value });
      if (isValueTypeOfObject) {
        isCustomForm = true;
        const parsedValue = field.value;
        if (parsedValue?.narrative) {
          narrative += parsedValue.narrative + '\n\n';
        }
      }
    });
  }

  if (!isCustomForm) {
    narrative = formatSections({
      fieldData: currentForm?.form?.json?.fields,
      answerData: fields
    });

    setNarrativeUpdated(true);
  }

  setCurrentForm((prev) => ({ ...prev, narrative, simple_narrative: narrative }));
};
